exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bloc_stat-csv-btn[data-v-5ddbc4ef]{cursor:pointer;display:flex;align-items:center;justify-content:center;padding:.5rem 1rem;border-radius:3px;transition:background-color .15s ease-in-out}.territory-suggestions[data-v-5ddbc4ef]{position:absolute;top:calc(100% + .25rem);left:0;right:0;z-index:1050;max-height:240px;overflow-y:auto}.stick-label-stats[data-v-5ddbc4ef]{background-color:#f5f8fa;width:-moz-fit-content;width:fit-content;min-width:100px;font-size:.7rem;margin-left:5px;color:#7d7d7d;border-top-left-radius:5px;border-top-right-radius:5px;margin-bottom:-4px}", ""]);

// exports
